module.exports = __webpack_public_path__ + "static/media/notif_msg_premio.2e5482b1.png";